import { AgGridReact } from "ag-grid-react";
import Cookies from "js-cookie";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FetchDataTypes } from "../../api/api";
import { Grid, GridReadyEvent } from "ag-grid-community";
import { formateDataCurr, formateDataPrec } from "../../utils/types";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import clsx from "clsx";


const SectorRebalance = () => {
  const [rowData, setRowData] = useState();
  const [rowRebalanceData, setRowRebalanceData] = useState();
  const [newTarger, setNewTarget] = useState<any>();
  const [first, setfirst] = useState([]);
  const [rebalanceTrades, setRebalanceTrades] = useState(false);
  const [showErrormsg, setShowErrormsg] = useState(false);
  const selectedClient:any = Cookies.get("client")
  
  function newTarget(props: any) {
    return (
      <input
        type="number"
        className="form-control form-control--small m-auto"
        value={newTarger}
        onChange={(e) => setNewTarget(e.target.value)}
      />
    );
  }

  const hashValueGetter = (params: any) => {
    return console.log(params.data);
  };
  useEffect(() => {
    console.log(newTarger);
  }, [first, newTarger]);

  console.log(newTarger);
  const defColumnDefs = useMemo(
    () => ({
      sortable: true,
      //flex:1
    }),
    []
  );

  const [columns, setColumns] = useState([
    { headerName: "Sector Name", field: "sectorName", flex: 1, width: 200 },
    {
      headerName: "Sector Balance",
      field: "sectorBalance",
      sortable: true,
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Sector Holdings %",
      field: "sectorHoldingsPct",
      cellRenderer: formateDataPrec,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Target %",
      field: "targetPct",
      cellRenderer: formateDataPrec,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Target Balance",
      field: "targetBalance",
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Buy / Sell",
      field: "buyOrSell",
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
  ]);

  const [inputvalue, setInputvalue] = useState<any>();

  function editableValue(p: any) {
    return (
      <input
        type="number"
        className="form-control"
        value={p.value}
        onChange={() => setInputvalue(p.value)}
      />
    );
  }

  const [columnsRebalanceTrades, setColumnsRebalanceTrades] = useState([
    { headerName: "Sector Name", field: "sectorName", width: 200, flex: 1 },
    {
      headerName: "symbol",
      field: "symbol",
      width: 100,
    },
    {
      headerName: "Qty",
      field: "qty",
      width: 100,
      cellClass: "textAlign",
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Price",
      field: "price",
      sortable: true,
      cellRenderer: formateDataCurr,
      width: 130,
      cellClass: "textAlign",
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Market Value",
      field: "marketValue",
      sortable: true,
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      headerClass: "headerTextAlign",
      width: 140,
    },
    {
      headerName: "Buy / Sell",
      field: "buyOrSell",
      //cellRenderer: editableValue,
      cellClass: "textAlign p-0",
      headerClass: "headerTextAlign",
      width: 140,
      editable: true,
    },
    {
      headerName: "Qty Buy / Sell",
      field: "qtyBuyOrSell",
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      headerClass: "headerTextAlign",
      width: 140,
    },
    {
      headerName: "Order Type",
      field: "orderType",
      width: 130,
      //cellRenderer: formateDataPrec,
      cellClass: "mx-4",
      headerClass: "mx-4",
    },
  ]);

  function handleSubmit() {
    setRebalanceTrades((current) => !current);
  }
  console.log(rebalanceTrades);
  const onGridReady = useCallback((params: GridReadyEvent) => {
    FetchDataTypes("SectorRebalance", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setRowData(response);
      });
  }, []);

  const onGridReadynew = useCallback((params: GridReadyEvent) => {
    FetchDataTypes("SectorRebalanceTrades", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setRowRebalanceData(response);
      });
  }, []);

  console.log(rowData);

  function showMessage() {
    setShowErrormsg(true);
  }
  return (
    <div className="mt-4">
      <div className="card mr-2 shadow-none">
        <div className="col-sm-3 w-100 py-3 justify-content-between tableFilters">
          <h5 className="card-title float-start">
            Sector Rebalance
            {rebalanceTrades === true ? " - Trades" : null}
          </h5>
        </div>
        {showErrormsg && showErrormsg ? (
          <div
            className="alert alert-danger alert-dismissible position-absolute statusAlert"
            role="alert"
          >
            <div className="alert-message">
ERROR: You have limited access and need approval from admin to execute the trades.</div>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
          
        ) : null}
        <div className="card-body p-0">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div className="chartjs-size-monitor-shrink">
                {rebalanceTrades === true ? (
                  <div
                    className="ag-theme-alpine"
                    style={{
                      height: "600px",
                      width: "100%",
                    }}
                  >
                    <AgGridReact
                      rowData={rowRebalanceData}
                      columnDefs={columnsRebalanceTrades}
                      defaultColDef={defColumnDefs}
                      onGridReady={onGridReadynew}
                      animateRows={true}
                      popupParent={document.body}
                    ></AgGridReact>
                  </div>
                ) : null}
                {rebalanceTrades === false ? (
                  <div
                    className="ag-theme-alpine"
                    style={{
                      height: "600px",
                      width: "100%",
                    }}
                  >
                    <AgGridReact
                      rowData={rowData}
                      columnDefs={columns}
                      defaultColDef={defColumnDefs}
                      onGridReady={onGridReady}
                      animateRows={true}
                      popupParent={document.body}
                    ></AgGridReact>
                  </div>
                ) : null}
              </div>
              <div className="row pt-4">
                <div className="float-end text-end">
                  {rebalanceTrades === true ? (
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={handleSubmit}
                    >
                      Cancel
                    </button>
                  ) : null}

                  <button
                    type="submit"
                    className={clsx("btn ",
                    rebalanceTrades === true ? 'btn-danger' : 'btn-primary'
                    )}
                    onClick={
                      rebalanceTrades === true ? showMessage : handleSubmit
                    }
                  >
                    {rebalanceTrades === true
                      ? "Place Trades"
                      : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { SectorRebalance };
